import {styled} from '@esgi/ui/theme';
import {Box} from '@esgi/ui/layout';

export const ReportFiltersLabelContainerStyled = styled(Box, {
	display: 'flex',
	marginBottom: '5px',
	marginRight: '7px',
});